var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"get-app__container"},[(_vm.appUrl)?_c('a',{staticClass:"get-app__button",class:{ '!bg-[#750DC4]': _vm.isCrosswordsPage },attrs:{"href":_vm.appUrl,"target":"_blank","title":"Get the WordFinder App"},on:{"click":_vm.onButtonClick}},[_vm._v("\n\t\tGET THE APP\n\t")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }